const COUNTRIES = [
  { code: 'AF', name: 'Afghanistan', timezones: ['Asia/Kabul'] },
  { code: 'AL', name: 'Albania', timezones: ['Europe/Tirane'] },
  { code: 'DZ', name: 'Algeria', timezones: ['Africa/Algiers'] },
  { code: 'AD', name: 'Andorra', timezones: ['Europe/Andorra'] },
  { code: 'AO', name: 'Angola', timezones: ['Africa/Luanda'] },
  { code: 'AG', name: 'Antigua and Barbuda', timezones: ['America/Antigua'] },
  { code: 'AR', name: 'Argentina', timezones: ['America/Argentina/Buenos_Aires', 'America/Argentina/Cordoba', 'America/Argentina/Salta', 'America/Argentina/Jujuy', 'America/Argentina/Catamarca', 'America/Argentina/Mendoza'] },
  { code: 'AM', name: 'Armenia', timezones: ['Asia/Yerevan'] },
  { code: 'AU', name: 'Australia', timezones: ['Australia/Sydney', 'Australia/Melbourne', 'Australia/Brisbane', 'Australia/Perth', 'Australia/Adelaide', 'Australia/Darwin', 'Australia/Hobart'] },
  { code: 'AT', name: 'Austria', timezones: ['Europe/Vienna'] },
  { code: 'AZ', name: 'Azerbaijan', timezones: ['Asia/Baku'] },
  { code: 'BS', name: 'Bahamas', timezones: ['America/Nassau'] },
  { code: 'BH', name: 'Bahrain', timezones: ['Asia/Bahrain'] },
  { code: 'BD', name: 'Bangladesh', timezones: ['Asia/Dhaka'] },
  { code: 'BB', name: 'Barbados', timezones: ['America/Barbados'] },
  { code: 'BY', name: 'Belarus', timezones: ['Europe/Minsk'] },
  { code: 'BE', name: 'Belgium', timezones: ['Europe/Brussels'] },
  { code: 'BZ', name: 'Belize', timezones: ['America/Belize'] },
  { code: 'BJ', name: 'Benin', timezones: ['Africa/Porto-Novo'] },
  { code: 'BT', name: 'Bhutan', timezones: ['Asia/Thimphu'] },
  { code: 'BO', name: 'Bolivia', timezones: ['America/La_Paz'] },
  { code: 'BA', name: 'Bosnia and Herzegovina', timezones: ['Europe/Sarajevo'] },
  { code: 'BW', name: 'Botswana', timezones: ['Africa/Gaborone'] },
  { code: 'BR', name: 'Brazil', timezones: ['America/Sao_Paulo', 'America/Manaus', 'America/Recife', 'America/Fortaleza', 'America/Belem', 'America/Cuiaba', 'America/Rio_Branco'] },
  { code: 'BN', name: 'Brunei', timezones: ['Asia/Brunei'] },
  { code: 'BG', name: 'Bulgaria', timezones: ['Europe/Sofia'] },
  { code: 'BF', name: 'Burkina Faso', timezones: ['Africa/Ouagadougou'] },
  { code: 'BI', name: 'Burundi', timezones: ['Africa/Bujumbura'] },
  { code: 'CV', name: 'Cabo Verde', timezones: ['Atlantic/Cape_Verde'] },
  { code: 'KH', name: 'Cambodia', timezones: ['Asia/Phnom_Penh'] },
  { code: 'CM', name: 'Cameroon', timezones: ['Africa/Douala'] },
  { code: 'CA', name: 'Canada', timezones: ['America/Toronto', 'America/Vancouver', 'America/Edmonton', 'America/Winnipeg', 'America/Halifax', 'America/St_Johns', 'America/Regina'] },
  { code: 'CF', name: 'Central African Republic', timezones: ['Africa/Bangui'] },
  { code: 'TD', name: 'Chad', timezones: ['Africa/Ndjamena'] },
  { code: 'CL', name: 'Chile', timezones: ['America/Santiago', 'Pacific/Easter'] },
  { code: 'CN', name: 'China', timezones: ['Asia/Shanghai', 'Asia/Urumqi'] },
  { code: 'CO', name: 'Colombia', timezones: ['America/Bogota'] },
  { code: 'KM', name: 'Comoros', timezones: ['Indian/Comoro'] },
  { code: 'CG', name: 'Congo', timezones: ['Africa/Brazzaville'] },
  { code: 'CD', name: 'Congo (DRC)', timezones: ['Africa/Kinshasa', 'Africa/Lubumbashi'] },
  { code: 'CR', name: 'Costa Rica', timezones: ['America/Costa_Rica'] },
  { code: 'CI', name: "Cote d'Ivoire", timezones: ['Africa/Abidjan'] },
  { code: 'HR', name: 'Croatia', timezones: ['Europe/Zagreb'] },
  { code: 'CU', name: 'Cuba', timezones: ['America/Havana'] },
  { code: 'CY', name: 'Cyprus', timezones: ['Asia/Nicosia'] },
  { code: 'CZ', name: 'Czech Republic', timezones: ['Europe/Prague'] },
  { code: 'DK', name: 'Denmark', timezones: ['Europe/Copenhagen'] },
  { code: 'DJ', name: 'Djibouti', timezones: ['Africa/Djibouti'] },
  { code: 'DM', name: 'Dominica', timezones: ['America/Dominica'] },
  { code: 'DO', name: 'Dominican Republic', timezones: ['America/Santo_Domingo'] },
  { code: 'EC', name: 'Ecuador', timezones: ['America/Guayaquil', 'Pacific/Galapagos'] },
  { code: 'EG', name: 'Egypt', timezones: ['Africa/Cairo'] },
  { code: 'SV', name: 'El Salvador', timezones: ['America/El_Salvador'] },
  { code: 'GQ', name: 'Equatorial Guinea', timezones: ['Africa/Malabo'] },
  { code: 'ER', name: 'Eritrea', timezones: ['Africa/Asmara'] },
  { code: 'EE', name: 'Estonia', timezones: ['Europe/Tallinn'] },
  { code: 'SZ', name: 'Eswatini', timezones: ['Africa/Mbabane'] },
  { code: 'ET', name: 'Ethiopia', timezones: ['Africa/Addis_Ababa'] },
  { code: 'FJ', name: 'Fiji', timezones: ['Pacific/Fiji'] },
  { code: 'FI', name: 'Finland', timezones: ['Europe/Helsinki'] },
  { code: 'FR', name: 'France', timezones: ['Europe/Paris'] },
  { code: 'GA', name: 'Gabon', timezones: ['Africa/Libreville'] },
  { code: 'GM', name: 'Gambia', timezones: ['Africa/Banjul'] },
  { code: 'GE', name: 'Georgia', timezones: ['Asia/Tbilisi'] },
  { code: 'DE', name: 'Germany', timezones: ['Europe/Berlin'] },
  { code: 'GH', name: 'Ghana', timezones: ['Africa/Accra'] },
  { code: 'GR', name: 'Greece', timezones: ['Europe/Athens'] },
  { code: 'GD', name: 'Grenada', timezones: ['America/Grenada'] },
  { code: 'GT', name: 'Guatemala', timezones: ['America/Guatemala'] },
  { code: 'GN', name: 'Guinea', timezones: ['Africa/Conakry'] },
  { code: 'GW', name: 'Guinea-Bissau', timezones: ['Africa/Bissau'] },
  { code: 'GY', name: 'Guyana', timezones: ['America/Guyana'] },
  { code: 'HT', name: 'Haiti', timezones: ['America/Port-au-Prince'] },
  { code: 'HN', name: 'Honduras', timezones: ['America/Tegucigalpa'] },
  { code: 'HU', name: 'Hungary', timezones: ['Europe/Budapest'] },
  { code: 'IS', name: 'Iceland', timezones: ['Atlantic/Reykjavik'] },
  { code: 'IN', name: 'India', timezones: ['Asia/Kolkata'] },
  { code: 'ID', name: 'Indonesia', timezones: ['Asia/Jakarta', 'Asia/Makassar', 'Asia/Jayapura'] },
  { code: 'IR', name: 'Iran', timezones: ['Asia/Tehran'] },
  { code: 'IQ', name: 'Iraq', timezones: ['Asia/Baghdad'] },
  { code: 'IE', name: 'Ireland', timezones: ['Europe/Dublin'] },
  { code: 'IT', name: 'Italy', timezones: ['Europe/Rome'] },
  { code: 'JM', name: 'Jamaica', timezones: ['America/Jamaica'] },
  { code: 'JP', name: 'Japan', timezones: ['Asia/Tokyo'] },
  { code: 'JO', name: 'Jordan', timezones: ['Asia/Amman'] },
  { code: 'KZ', name: 'Kazakhstan', timezones: ['Asia/Almaty', 'Asia/Aqtobe', 'Asia/Oral'] },
  { code: 'KE', name: 'Kenya', timezones: ['Africa/Nairobi'] },
  { code: 'KI', name: 'Kiribati', timezones: ['Pacific/Tarawa'] },
  { code: 'KW', name: 'Kuwait', timezones: ['Asia/Kuwait'] },
  { code: 'KG', name: 'Kyrgyzstan', timezones: ['Asia/Bishkek'] },
  { code: 'LA', name: 'Laos', timezones: ['Asia/Vientiane'] },
  { code: 'LV', name: 'Latvia', timezones: ['Europe/Riga'] },
  { code: 'LB', name: 'Lebanon', timezones: ['Asia/Beirut'] },
  { code: 'LS', name: 'Lesotho', timezones: ['Africa/Maseru'] },
  { code: 'LR', name: 'Liberia', timezones: ['Africa/Monrovia'] },
  { code: 'LY', name: 'Libya', timezones: ['Africa/Tripoli'] },
  { code: 'LI', name: 'Liechtenstein', timezones: ['Europe/Vaduz'] },
  { code: 'LT', name: 'Lithuania', timezones: ['Europe/Vilnius'] },
  { code: 'LU', name: 'Luxembourg', timezones: ['Europe/Luxembourg'] },
  { code: 'MG', name: 'Madagascar', timezones: ['Indian/Antananarivo'] },
  { code: 'MW', name: 'Malawi', timezones: ['Africa/Blantyre'] },
  { code: 'MY', name: 'Malaysia', timezones: ['Asia/Kuala_Lumpur'] },
  { code: 'MV', name: 'Maldives', timezones: ['Indian/Maldives'] },
  { code: 'ML', name: 'Mali', timezones: ['Africa/Bamako'] },
  { code: 'MT', name: 'Malta', timezones: ['Europe/Malta'] },
  { code: 'MR', name: 'Mauritania', timezones: ['Africa/Nouakchott'] },
  { code: 'MU', name: 'Mauritius', timezones: ['Indian/Mauritius'] },
  { code: 'MX', name: 'Mexico', timezones: ['America/Mexico_City', 'America/Cancun', 'America/Monterrey', 'America/Tijuana', 'America/Chihuahua'] },
  { code: 'MD', name: 'Moldova', timezones: ['Europe/Chisinau'] },
  { code: 'MC', name: 'Monaco', timezones: ['Europe/Monaco'] },
  { code: 'MN', name: 'Mongolia', timezones: ['Asia/Ulaanbaatar'] },
  { code: 'ME', name: 'Montenegro', timezones: ['Europe/Podgorica'] },
  { code: 'MA', name: 'Morocco', timezones: ['Africa/Casablanca'] },
  { code: 'MZ', name: 'Mozambique', timezones: ['Africa/Maputo'] },
  { code: 'MM', name: 'Myanmar', timezones: ['Asia/Yangon'] },
  { code: 'NA', name: 'Namibia', timezones: ['Africa/Windhoek'] },
  { code: 'NP', name: 'Nepal', timezones: ['Asia/Kathmandu'] },
  { code: 'NL', name: 'Netherlands', timezones: ['Europe/Amsterdam'] },
  { code: 'NZ', name: 'New Zealand', timezones: ['Pacific/Auckland', 'Pacific/Chatham'] },
  { code: 'NI', name: 'Nicaragua', timezones: ['America/Managua'] },
  { code: 'NE', name: 'Niger', timezones: ['Africa/Niamey'] },
  { code: 'NG', name: 'Nigeria', timezones: ['Africa/Lagos'] },
  { code: 'KP', name: 'North Korea', timezones: ['Asia/Pyongyang'] },
  { code: 'MK', name: 'North Macedonia', timezones: ['Europe/Skopje'] },
  { code: 'NO', name: 'Norway', timezones: ['Europe/Oslo'] },
  { code: 'OM', name: 'Oman', timezones: ['Asia/Muscat'] },
  { code: 'PK', name: 'Pakistan', timezones: ['Asia/Karachi'] },
  { code: 'PA', name: 'Panama', timezones: ['America/Panama'] },
  { code: 'PG', name: 'Papua New Guinea', timezones: ['Pacific/Port_Moresby'] },
  { code: 'PY', name: 'Paraguay', timezones: ['America/Asuncion'] },
  { code: 'PE', name: 'Peru', timezones: ['America/Lima'] },
  { code: 'PH', name: 'Philippines', timezones: ['Asia/Manila'] },
  { code: 'PL', name: 'Poland', timezones: ['Europe/Warsaw'] },
  { code: 'PT', name: 'Portugal', timezones: ['Europe/Lisbon', 'Atlantic/Azores'] },
  { code: 'QA', name: 'Qatar', timezones: ['Asia/Qatar'] },
  { code: 'RO', name: 'Romania', timezones: ['Europe/Bucharest'] },
  { code: 'RU', name: 'Russia', timezones: ['Europe/Moscow', 'Europe/Kaliningrad', 'Asia/Yekaterinburg', 'Asia/Novosibirsk', 'Asia/Krasnoyarsk', 'Asia/Irkutsk', 'Asia/Yakutsk', 'Asia/Vladivostok', 'Asia/Kamchatka'] },
  { code: 'RW', name: 'Rwanda', timezones: ['Africa/Kigali'] },
  { code: 'SA', name: 'Saudi Arabia', timezones: ['Asia/Riyadh'] },
  { code: 'SN', name: 'Senegal', timezones: ['Africa/Dakar'] },
  { code: 'RS', name: 'Serbia', timezones: ['Europe/Belgrade'] },
  { code: 'SG', name: 'Singapore', timezones: ['Asia/Singapore'] },
  { code: 'SK', name: 'Slovakia', timezones: ['Europe/Bratislava'] },
  { code: 'SI', name: 'Slovenia', timezones: ['Europe/Ljubljana'] },
  { code: 'SO', name: 'Somalia', timezones: ['Africa/Mogadishu'] },
  { code: 'ZA', name: 'South Africa', timezones: ['Africa/Johannesburg'] },
  { code: 'KR', name: 'South Korea', timezones: ['Asia/Seoul'] },
  { code: 'SS', name: 'South Sudan', timezones: ['Africa/Juba'] },
  { code: 'ES', name: 'Spain', timezones: ['Europe/Madrid', 'Atlantic/Canary'] },
  { code: 'LK', name: 'Sri Lanka', timezones: ['Asia/Colombo'] },
  { code: 'SD', name: 'Sudan', timezones: ['Africa/Khartoum'] },
  { code: 'SR', name: 'Suriname', timezones: ['America/Paramaribo'] },
  { code: 'SE', name: 'Sweden', timezones: ['Europe/Stockholm'] },
  { code: 'CH', name: 'Switzerland', timezones: ['Europe/Zurich'] },
  { code: 'SY', name: 'Syria', timezones: ['Asia/Damascus'] },
  { code: 'TW', name: 'Taiwan', timezones: ['Asia/Taipei'] },
  { code: 'TJ', name: 'Tajikistan', timezones: ['Asia/Dushanbe'] },
  { code: 'TZ', name: 'Tanzania', timezones: ['Africa/Dar_es_Salaam'] },
  { code: 'TH', name: 'Thailand', timezones: ['Asia/Bangkok'] },
  { code: 'TL', name: 'Timor-Leste', timezones: ['Asia/Dili'] },
  { code: 'TG', name: 'Togo', timezones: ['Africa/Lome'] },
  { code: 'TT', name: 'Trinidad and Tobago', timezones: ['America/Port_of_Spain'] },
  { code: 'TN', name: 'Tunisia', timezones: ['Africa/Tunis'] },
  { code: 'TR', name: 'Turkey', timezones: ['Europe/Istanbul'] },
  { code: 'TM', name: 'Turkmenistan', timezones: ['Asia/Ashgabat'] },
  { code: 'UG', name: 'Uganda', timezones: ['Africa/Kampala'] },
  { code: 'UA', name: 'Ukraine', timezones: ['Europe/Kiev'] },
  { code: 'AE', name: 'United Arab Emirates', timezones: ['Asia/Dubai'] },
  { code: 'GB', name: 'United Kingdom', timezones: ['Europe/London'] },
  { code: 'US', name: 'United States', timezones: ['America/New_York', 'America/Chicago', 'America/Denver', 'America/Los_Angeles', 'America/Anchorage', 'Pacific/Honolulu', 'America/Phoenix'] },
  { code: 'UY', name: 'Uruguay', timezones: ['America/Montevideo'] },
  { code: 'UZ', name: 'Uzbekistan', timezones: ['Asia/Tashkent'] },
  { code: 'VE', name: 'Venezuela', timezones: ['America/Caracas'] },
  { code: 'VN', name: 'Vietnam', timezones: ['Asia/Ho_Chi_Minh'] },
  { code: 'YE', name: 'Yemen', timezones: ['Asia/Aden'] },
  { code: 'ZM', name: 'Zambia', timezones: ['Africa/Lusaka'] },
  { code: 'ZW', name: 'Zimbabwe', timezones: ['Africa/Harare'] },
];

// Human-readable labels for IANA timezone identifiers
const TIMEZONE_LABELS = {
  // Americas
  'America/New_York': 'Eastern Time (ET)',
  'America/Chicago': 'Central Time (CT)',
  'America/Denver': 'Mountain Time (MT)',
  'America/Los_Angeles': 'Pacific Time (PT)',
  'America/Anchorage': 'Alaska Time (AKT)',
  'Pacific/Honolulu': 'Hawaii Time (HST)',
  'America/Phoenix': 'Arizona (MST)',
  'America/Toronto': 'Toronto (ET)',
  'America/Vancouver': 'Vancouver (PT)',
  'America/Edmonton': 'Edmonton (MT)',
  'America/Winnipeg': 'Winnipeg (CT)',
  'America/Halifax': 'Halifax (AT)',
  'America/St_Johns': "St. John's (NT)",
  'America/Regina': 'Saskatchewan (CST)',
  'America/Mexico_City': 'Mexico City (CST)',
  'America/Cancun': 'Cancun (EST)',
  'America/Monterrey': 'Monterrey (CST)',
  'America/Tijuana': 'Tijuana (PST)',
  'America/Chihuahua': 'Chihuahua (MST)',
  'America/Sao_Paulo': 'Sao Paulo (BRT)',
  'America/Manaus': 'Manaus (AMT)',
  'America/Recife': 'Recife (BRT)',
  'America/Fortaleza': 'Fortaleza (BRT)',
  'America/Belem': 'Belem (BRT)',
  'America/Cuiaba': 'Cuiaba (AMT)',
  'America/Rio_Branco': 'Rio Branco (ACT)',
  'America/Argentina/Buenos_Aires': 'Buenos Aires (ART)',
  'America/Argentina/Cordoba': 'Cordoba (ART)',
  'America/Argentina/Salta': 'Salta (ART)',
  'America/Argentina/Jujuy': 'Jujuy (ART)',
  'America/Argentina/Catamarca': 'Catamarca (ART)',
  'America/Argentina/Mendoza': 'Mendoza (ART)',
  'America/Bogota': 'Bogota (COT)',
  'America/Lima': 'Lima (PET)',
  'America/Santiago': 'Santiago (CLT)',
  'America/Caracas': 'Caracas (VET)',
  'America/La_Paz': 'La Paz (BOT)',
  'America/Asuncion': 'Asuncion (PYT)',
  'America/Montevideo': 'Montevideo (UYT)',
  'America/Guayaquil': 'Guayaquil (ECT)',
  'America/Havana': 'Havana (CST)',
  'America/Panama': 'Panama (EST)',
  'America/Paramaribo': 'Paramaribo (SRT)',
  'America/Port-au-Prince': 'Port-au-Prince (EST)',
  'America/Port_of_Spain': 'Port of Spain (AST)',
  'America/Santo_Domingo': 'Santo Domingo (AST)',
  'America/Guatemala': 'Guatemala (CST)',
  'America/Tegucigalpa': 'Tegucigalpa (CST)',
  'America/Managua': 'Managua (CST)',
  'America/Costa_Rica': 'Costa Rica (CST)',
  'America/El_Salvador': 'El Salvador (CST)',
  'America/Belize': 'Belize (CST)',
  'America/Jamaica': 'Jamaica (EST)',
  'America/Nassau': 'Nassau (EST)',
  'America/Barbados': 'Barbados (AST)',
  'America/Antigua': 'Antigua (AST)',
  'America/Dominica': 'Dominica (AST)',
  'America/Grenada': 'Grenada (AST)',
  'America/Guyana': 'Guyana (GYT)',
  'Pacific/Easter': 'Easter Island (EAST)',
  'Pacific/Galapagos': 'Galapagos (GALT)',

  // Europe
  'Europe/London': 'London (GMT)',
  'Europe/Paris': 'Paris (CET)',
  'Europe/Berlin': 'Berlin (CET)',
  'Europe/Madrid': 'Madrid (CET)',
  'Europe/Rome': 'Rome (CET)',
  'Europe/Amsterdam': 'Amsterdam (CET)',
  'Europe/Brussels': 'Brussels (CET)',
  'Europe/Zurich': 'Zurich (CET)',
  'Europe/Vienna': 'Vienna (CET)',
  'Europe/Stockholm': 'Stockholm (CET)',
  'Europe/Oslo': 'Oslo (CET)',
  'Europe/Copenhagen': 'Copenhagen (CET)',
  'Europe/Helsinki': 'Helsinki (EET)',
  'Europe/Warsaw': 'Warsaw (CET)',
  'Europe/Prague': 'Prague (CET)',
  'Europe/Budapest': 'Budapest (CET)',
  'Europe/Bucharest': 'Bucharest (EET)',
  'Europe/Sofia': 'Sofia (EET)',
  'Europe/Athens': 'Athens (EET)',
  'Europe/Istanbul': 'Istanbul (TRT)',
  'Europe/Moscow': 'Moscow (MSK)',
  'Europe/Kaliningrad': 'Kaliningrad (EET)',
  'Europe/Kiev': 'Kyiv (EET)',
  'Europe/Minsk': 'Minsk (MSK)',
  'Europe/Dublin': 'Dublin (GMT)',
  'Europe/Lisbon': 'Lisbon (WET)',
  'Europe/Tirane': 'Tirana (CET)',
  'Europe/Andorra': 'Andorra (CET)',
  'Europe/Sarajevo': 'Sarajevo (CET)',
  'Europe/Zagreb': 'Zagreb (CET)',
  'Europe/Tallinn': 'Tallinn (EET)',
  'Europe/Riga': 'Riga (EET)',
  'Europe/Vilnius': 'Vilnius (EET)',
  'Europe/Luxembourg': 'Luxembourg (CET)',
  'Europe/Malta': 'Malta (CET)',
  'Europe/Chisinau': 'Chisinau (EET)',
  'Europe/Monaco': 'Monaco (CET)',
  'Europe/Podgorica': 'Podgorica (CET)',
  'Europe/Belgrade': 'Belgrade (CET)',
  'Europe/Bratislava': 'Bratislava (CET)',
  'Europe/Ljubljana': 'Ljubljana (CET)',
  'Europe/Skopje': 'Skopje (CET)',
  'Europe/Vaduz': 'Vaduz (CET)',
  'Atlantic/Reykjavik': 'Reykjavik (GMT)',
  'Atlantic/Azores': 'Azores (AZOT)',
  'Atlantic/Canary': 'Canary Islands (WET)',

  // Asia
  'Asia/Dubai': 'Dubai (GST)',
  'Asia/Riyadh': 'Riyadh (AST)',
  'Asia/Tehran': 'Tehran (IRST)',
  'Asia/Kolkata': 'India (IST)',
  'Asia/Tokyo': 'Tokyo (JST)',
  'Asia/Shanghai': 'Shanghai (CST)',
  'Asia/Urumqi': 'Urumqi (XJT)',
  'Asia/Hong_Kong': 'Hong Kong (HKT)',
  'Asia/Singapore': 'Singapore (SGT)',
  'Asia/Seoul': 'Seoul (KST)',
  'Asia/Taipei': 'Taipei (CST)',
  'Asia/Bangkok': 'Bangkok (ICT)',
  'Asia/Jakarta': 'Jakarta (WIB)',
  'Asia/Makassar': 'Makassar (WITA)',
  'Asia/Jayapura': 'Jayapura (WIT)',
  'Asia/Karachi': 'Karachi (PKT)',
  'Asia/Dhaka': 'Dhaka (BST)',
  'Asia/Kuala_Lumpur': 'Kuala Lumpur (MYT)',
  'Asia/Manila': 'Manila (PHT)',
  'Asia/Ho_Chi_Minh': 'Ho Chi Minh (ICT)',
  'Asia/Yangon': 'Yangon (MMT)',
  'Asia/Kabul': 'Kabul (AFT)',
  'Asia/Baghdad': 'Baghdad (AST)',
  'Asia/Beirut': 'Beirut (EET)',
  'Asia/Amman': 'Amman (EET)',
  'Asia/Damascus': 'Damascus (EET)',
  'Asia/Jerusalem': 'Jerusalem (IST)',
  'Asia/Nicosia': 'Nicosia (EET)',
  'Asia/Tbilisi': 'Tbilisi (GET)',
  'Asia/Yerevan': 'Yerevan (AMT)',
  'Asia/Baku': 'Baku (AZT)',
  'Asia/Qatar': 'Qatar (AST)',
  'Asia/Kuwait': 'Kuwait (AST)',
  'Asia/Bahrain': 'Bahrain (AST)',
  'Asia/Muscat': 'Muscat (GST)',
  'Asia/Aden': 'Aden (AST)',
  'Asia/Almaty': 'Almaty (ALMT)',
  'Asia/Aqtobe': 'Aqtobe (AQTT)',
  'Asia/Oral': 'Oral (ORAT)',
  'Asia/Tashkent': 'Tashkent (UZT)',
  'Asia/Bishkek': 'Bishkek (KGT)',
  'Asia/Dushanbe': 'Dushanbe (TJT)',
  'Asia/Ashgabat': 'Ashgabat (TMT)',
  'Asia/Thimphu': 'Thimphu (BTT)',
  'Asia/Kathmandu': 'Kathmandu (NPT)',
  'Asia/Colombo': 'Colombo (IST)',
  'Asia/Phnom_Penh': 'Phnom Penh (ICT)',
  'Asia/Vientiane': 'Vientiane (ICT)',
  'Asia/Ulaanbaatar': 'Ulaanbaatar (ULAT)',
  'Asia/Pyongyang': 'Pyongyang (KST)',
  'Asia/Dili': 'Dili (TLT)',
  'Asia/Brunei': 'Brunei (BNT)',
  'Asia/Yekaterinburg': 'Yekaterinburg (YEKT)',
  'Asia/Novosibirsk': 'Novosibirsk (NOVT)',
  'Asia/Krasnoyarsk': 'Krasnoyarsk (KRAT)',
  'Asia/Irkutsk': 'Irkutsk (IRKT)',
  'Asia/Yakutsk': 'Yakutsk (YAKT)',
  'Asia/Vladivostok': 'Vladivostok (VLAT)',
  'Asia/Kamchatka': 'Kamchatka (PETT)',

  // Africa
  'Africa/Cairo': 'Cairo (EET)',
  'Africa/Lagos': 'Lagos (WAT)',
  'Africa/Nairobi': 'Nairobi (EAT)',
  'Africa/Johannesburg': 'Johannesburg (SAST)',
  'Africa/Casablanca': 'Casablanca (WET)',
  'Africa/Algiers': 'Algiers (CET)',
  'Africa/Tunis': 'Tunis (CET)',
  'Africa/Tripoli': 'Tripoli (EET)',
  'Africa/Khartoum': 'Khartoum (CAT)',
  'Africa/Addis_Ababa': 'Addis Ababa (EAT)',
  'Africa/Dar_es_Salaam': 'Dar es Salaam (EAT)',
  'Africa/Kampala': 'Kampala (EAT)',
  'Africa/Kigali': 'Kigali (CAT)',
  'Africa/Maputo': 'Maputo (CAT)',
  'Africa/Windhoek': 'Windhoek (CAT)',
  'Africa/Luanda': 'Luanda (WAT)',
  'Africa/Douala': 'Douala (WAT)',
  'Africa/Accra': 'Accra (GMT)',
  'Africa/Dakar': 'Dakar (GMT)',
  'Africa/Abidjan': 'Abidjan (GMT)',
  'Africa/Monrovia': 'Monrovia (GMT)',
  'Africa/Bamako': 'Bamako (GMT)',
  'Africa/Conakry': 'Conakry (GMT)',
  'Africa/Bissau': 'Bissau (GMT)',
  'Africa/Ouagadougou': 'Ouagadougou (GMT)',
  'Africa/Niamey': 'Niamey (WAT)',
  'Africa/Ndjamena': "N'Djamena (WAT)",
  'Africa/Bangui': 'Bangui (WAT)',
  'Africa/Brazzaville': 'Brazzaville (WAT)',
  'Africa/Kinshasa': 'Kinshasa (WAT)',
  'Africa/Lubumbashi': 'Lubumbashi (CAT)',
  'Africa/Malabo': 'Malabo (WAT)',
  'Africa/Libreville': 'Libreville (WAT)',
  'Africa/Bujumbura': 'Bujumbura (CAT)',
  'Africa/Porto-Novo': 'Porto-Novo (WAT)',
  'Africa/Lome': 'Lome (GMT)',
  'Africa/Banjul': 'Banjul (GMT)',
  'Africa/Djibouti': 'Djibouti (EAT)',
  'Africa/Asmara': 'Asmara (EAT)',
  'Africa/Mogadishu': 'Mogadishu (EAT)',
  'Africa/Juba': 'Juba (CAT)',
  'Africa/Gaborone': 'Gaborone (CAT)',
  'Africa/Maseru': 'Maseru (SAST)',
  'Africa/Mbabane': 'Mbabane (SAST)',
  'Africa/Blantyre': 'Blantyre (CAT)',
  'Africa/Lusaka': 'Lusaka (CAT)',
  'Africa/Harare': 'Harare (CAT)',
  'Indian/Antananarivo': 'Antananarivo (EAT)',
  'Indian/Mauritius': 'Mauritius (MUT)',
  'Indian/Comoro': 'Comoro (EAT)',
  'Indian/Maldives': 'Maldives (MVT)',
  'Africa/Nouakchott': 'Nouakchott (GMT)',

  // Oceania
  'Australia/Sydney': 'Sydney (AEST)',
  'Australia/Melbourne': 'Melbourne (AEST)',
  'Australia/Brisbane': 'Brisbane (AEST)',
  'Australia/Perth': 'Perth (AWST)',
  'Australia/Adelaide': 'Adelaide (ACST)',
  'Australia/Darwin': 'Darwin (ACST)',
  'Australia/Hobart': 'Hobart (AEST)',
  'Pacific/Auckland': 'Auckland (NZST)',
  'Pacific/Chatham': 'Chatham Islands (CHAST)',
  'Pacific/Fiji': 'Fiji (FJT)',
  'Pacific/Port_Moresby': 'Port Moresby (PGT)',
  'Pacific/Tarawa': 'Tarawa (GILT)',
};

export function getTimezoneLabel(tz) {
  return TIMEZONE_LABELS[tz] || tz.replace(/_/g, ' ').split('/').pop();
}

export function getTimezonesForCountry(countryCode) {
  const country = COUNTRIES.find(c => c.code === countryCode);
  return country ? country.timezones : [];
}

export default COUNTRIES;
